import type { EventName } from "@lit-labs/react";
import { Dialog as DialogElement, type DialogEventMap as _DialogEventMap, } from "@vaadin/dialog/vaadin-dialog.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DialogElement, };
export type DialogEventMap = Readonly<{
    onResize: EventName<_DialogEventMap["resize"]>;
    onOpenedChanged: EventName<_DialogEventMap["opened-changed"]>;
}>;
const events = { onResize: "resize", onOpenedChanged: "opened-changed" } as DialogEventMap;
export type DialogProps = WebComponentProps<DialogElement, DialogEventMap>;
export const Dialog = createComponent({
    elementClass: DialogElement, events, react: React, tagName: "vaadin-dialog"
});
